// extracted by mini-css-extract-plugin
module.exports = {"container":"ResetPassword__container--1Ge_V","root":"ResetPassword__root--r4tnp Layout__form--4yOS_"};